import {
  createBiLogger as createCliBiLogger,
  reportCommandStartEvent as originalReportCommandStartEvent,
} from '@wix/cli-telemetry';
import { getUnknownFailureMessage, isCliSystemError } from '@wix/cli-error';
import type { ErrorReporter } from '@wix/cli-error-reporting';
import { wixCliCliError } from '@wix/bi-logger-dev-tools-data/v2';
import type { Command } from '@commander-js/extra-typings';
import packageJson from '../../package.json' with { type: 'json' };

export const createBiLogger = async ({
  errorReporter,
  cliSessionId,
  aiAgentName,
  userId,
}: {
  errorReporter: ErrorReporter;
  cliSessionId: string;
  userId?: string;
  aiAgentName?: string;
}) => {
  const biLogger = await createCliBiLogger({
    aiAgentName,
    command: 'create-app',
    cliSessionId,
    cliVersion: packageJson.version,
    userId,
  });

  errorReporter.on('errorReported', (error) => {
    void biLogger.report(
      wixCliCliError({
        errorMessage: getUnknownFailureMessage(error),
        errorType: isCliSystemError(error) ? 'SystemError' : 'UserError',
        errorName: error.name,
      })
    );
  });

  function reportCommandStartEvent(command: Command) {
    // creating a custom object because we need to change the name of the command
    const commandFields = {
      name: () => 'create-app',
      args: command.args,
      opts: () => command.opts(),
    };

    return originalReportCommandStartEvent({
      biLogger,
      command: commandFields,
      cliVersion: packageJson.version,
      flow: 'Apps',
    });
  }

  return {
    biLogger,
    reportCommandStartEvent,
  };
};
